<template>
  <div>
    <div class="form-control" style="height: 100px; position: relative">
      <b-form-file
        :id="id"
        plain
        v-model="innerValue"
        :accept="accept"
        :name="name"
        v-validate="vValidate"
        :style="{
          height: '100%',
          opacity: 0,
          position: 'relative',
          zIndex: 10,
          cursor: 'pointer',
        }"
      ></b-form-file>
      <span
        style="
          position: absolute;
          z-index: 0;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        "
      >
        {{ innerValue ? innerValue.name : 'Upload File' }}
      </span>
    </div>
    <span class="text-danger" v-if="$validator.errors.has(name, 'file_size')">
      {{ $validator.errors.first(name, 'file_size') }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'FileUpload',
  props: {
    value: {
      type: [File, String, null],
      default: null,
    },
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    accept: {
      type: String,
      default: '.pdf',
    },
    vValidate: {
      type: String,
      default: 'required',
    },
  },
  data() {
    return {
      innerValue: this.value,
    }
  },
  watch: {
    innerValue(val) {
      const maxSize = 5 * 1024 * 1024
      if (val && val.size > maxSize) {
        this.$validator.errors.add({
          field: this.name,
          msg: 'Ukuran file maksimal 5MB',
          scope: 'file_size',
        })
        this.$emit('input', null)
      } else {
        this.$validator.errors.remove(this.name, 'file_size')
        this.$emit('input', val)
      }
    },
    value(val) {
      this.innerValue = val
    },
  },
}
</script>
